import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

class DashboardHeader extends Component {

  subscriptionStatus() {
    const { user } = this.props

    return user.paid_content
    ? 'Premier'
    : 'Free Trial'
  }

  render() {
    const { user } = this.props;

    const  userIsNotAdmin = (user.role === 'admin' || user.role === 'super admin') ? false : true

    return (
      <div>
        <section className='dashboard-header'>
          <div className='inner-wrap'>
            <div className='user-overview'>
              { userIsNotAdmin &&
                <span>{this.subscriptionStatus()} Member</span>
              }
              <span>{user.role}</span>
            </div>
            <h1 className='alt'>Hey, {user.first_name}</h1>
            { userIsNotAdmin &&
              <Link to='/settings'>Edit Account</Link>
            }
          </div>
        </section>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.user,
  }
}

export default connect(
  mapStateToProps,
  null
)(DashboardHeader)



// WEBPACK FOOTER //
// ./src/components/Dashboard/DashboardHeader.js